import { FeatureFlag } from '@ndvr/auth-api';

import { useAssignedFlags } from './auth-queries';

export const useFeatureFlag = (flag: FeatureFlag) => {
    const { data } = useAssignedFlags();

    return data?.includes(flag);
};
